(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photos-txt-arguments"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const slider = document.querySelector('.sleepy-why__grid');
  if (!slider) return;

  function initSleepySwiper(){

    if (window.matchMedia("(max-width: 767px)").matches){

      if(slider.classList.contains('swiper-initialized')) return;

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: '.sleepy-why__grid .swiper-button-next',
          prevEl: '.sleepy-why__grid .swiper-button-prev'
        }
      });

    }

  }

  setTimeout(initSleepySwiper, 50);


  const cols = document.querySelectorAll('.sleepy-compare-col');
  const cards = document.querySelectorAll('.sleepy-card');
  const container = document.querySelector('.sleepy-why__container');

  function activate(tab) {

    cols.forEach(col =>
      col.classList.toggle('is-active', col.dataset.tab === tab)
    );

    cards.forEach(card => {
      card.style.display = card.dataset.tab === tab ? '' : 'none';
    });

    if (container) {
      container.classList.toggle('is-tab1', tab === 'tab1');
      container.classList.toggle('is-tab2', tab === 'tab2');
    }

    equalizeSleepyCards();
  }

  cols.forEach(col => {
    col.addEventListener('click', () => activate(col.dataset.tab));
  });

  activate('tab1');


  equalizeSleepyCards();

  window.addEventListener('resize', () => {
    equalizeSleepyCards();
  });

});


function equalizeSleepyCards() {

  const cards = document.querySelectorAll('.sleepy-card__content');
  if (!cards.length) return;

  cards.forEach(card => {
    card.style.height = 'auto';
  });

  let maxHeight = 0;

  cards.forEach(card => {
    maxHeight = Math.max(maxHeight, card.offsetHeight);
  });

  cards.forEach(card => {
    card.style.height = maxHeight + 'px';
  });

}


  } catch(e) { console.error(e); }
})();
})();
